import { MATERIALS, DEFAULT_H, LABOUR, ROOM_TEMPLATES } from "../constants";

export function getWallMetrics(eId, st) {
  const e = st.edges[eId]; if (!e) return null;
  const ab = st.halfEdges[e.halfEdgeA], ba = st.halfEdges[e.halfEdgeB];
  if (!ab || !ba) return null;
  const nA = st.nodes[ab.originId], nB = st.nodes[ba.originId];
  if (!nA || !nB) return null;

  const lenMm = Math.round(Math.sqrt((nB.x - nA.x) ** 2 + (nB.y - nA.y) ** 2));
  const thickMm = e.thickness || 230, heightMm = e.height || DEFAULT_H;
  const mat = MATERIALS[e.materialId || "BRICK"];
  if (!mat) return null; // Guard: skip if material is undefined
  const lenM = lenMm / 1000, thickM = thickMm / 1000, heightM = heightMm / 1000;
  const grossVol = lenM * thickM * heightM;

  const ops = Object.values(st.openings || {}).filter(o => o.edgeId === eId);
  let opVol = 0, opArea = 0;
  for (const op of ops) {
    opVol  += op.width / 1000 * op.height / 1000 * thickM;
    opArea += op.width / 1000 * op.height / 1000;
  }

  const netVol = Math.max(0, grossVol - opVol);
  let matCost = 0;
  if (mat.rateM2) {
    const grossArea = lenM * heightM;
    matCost = Math.max(0, grossArea - opArea) * mat.rateM2;
  } else {
    matCost = netVol * (mat.rateM3 || 4500);
  }

  const labourCost = matCost * LABOUR;
  const totalCost  = matCost + labourCost;
  const bricks  = Math.ceil(netVol * mat.bricksPerM3);
  const cement  = +(netVol * mat.cementBagsPerM3).toFixed(1);
  const sand    = +(netVol * mat.sandCftPerM3).toFixed(1);

  return { lenMm, thickMm, heightMm, grossVol, netVol, mat, matCost, labourCost, totalCost, bricks, cement, sand, ops };
}

export function getRoomMetrics(faceId, st) {
  const face = st.faces[faceId]; if (!face) return null;
  const areaM2 = face.area / 1e6;
  const rd = (st.rooms || {})[faceId] || { type: "ROOM", name: "" };
  const tmpl = ROOM_TEMPLATES[rd.type] || ROOM_TEMPLATES.ROOM;
  const floorCost = areaM2 * tmpl.floorR;

  const perimMm = face.loop.reduce((sum, hid) => {
    const he = st.halfEdges[hid];
    const nA = he ? st.nodes[he.originId] : null;
    const nB = he ? st.nodes[st.halfEdges[he.twinId]?.originId] : null;
    return nA && nB ? sum + Math.sqrt((nB.x - nA.x) ** 2 + (nB.y - nA.y) ** 2) : sum;
  }, 0);

  const wallAreaM2 = (perimMm / 1000) * (DEFAULT_H / 1000);
  const wallCost   = wallAreaM2 * tmpl.wallR;
  const totalCost  = floorCost + wallCost;

  return { areaM2, perimMm, wallAreaM2, floorCost, wallCost, totalCost, rd, tmpl };
}

export function getProjectBOQ(st) {
  let wallCost = 0, labourCost = 0, bricks = 0, cement = 0, sand = 0, roomCost = 0;
  const byMat = {};

  for (const eId of Object.keys(st.edges)) {
    const m = getWallMetrics(eId, st); if (!m) continue;
    wallCost   += m.matCost;
    labourCost += m.labourCost;
    bricks     += m.bricks;
    cement     += m.cement;
    sand       += m.sand;
    if (!byMat[m.mat.id]) byMat[m.mat.id] = { mat: m.mat, vol: 0, cost: 0 };
    byMat[m.mat.id].vol  += m.netVol;
    byMat[m.mat.id].cost += m.matCost;
  }
  for (const fId of Object.keys(st.faces)) {
    const r = getRoomMetrics(fId, st); if (r) roomCost += r.totalCost;
  }

  return { wallCost, labourCost, roomCost, totalCost: wallCost + labourCost + roomCost, bricks, cement, sand, byMat };
}
